var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "addressApprovalWarning",
        value: true,
        "no-backdrop-dismiss": ""
      },
      on: {
        hide: function($event) {
          _vm.$emit("cancel")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header", color: "warning" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "warning" } }),
                  _vm._v("\n        Student Address Warning\n      ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.$emit("cancel")
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "address-approval-warning" }, [
            _c(
              "p",
              [
                _vm._v("\n        Of the "),
                _c("b", [_vm._v(_vm._s(_vm.result.total))]),
                _vm._v(" students in this class,\n        "),
                _vm.result.unverified
                  ? [
                      _c("b", [_vm._v(_vm._s(_vm.result.unverified))]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.result.unverified === 1
                              ? "has an address"
                              : "have addresses"
                          ) +
                          " Google could not validate\n        "
                      )
                    ]
                  : _vm._e(),
                _vm.result.unverified && _vm.result.fix
                  ? [_vm._v(" and ")]
                  : _vm._e(),
                _vm.result.fix
                  ? [
                      _c("b", [_vm._v(_vm._s(_vm.result.fix))]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.result.fix === 1
                              ? "has an address"
                              : "have addresses"
                          ) +
                          " Google has a correction for\n        "
                      )
                    ]
                  : _vm._e(),
                _vm._v(".\n        You can still approve the class.\n      ")
              ],
              2
            ),
            _vm.result.unchecked
              ? _c("p", { staticClass: "text-faded" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.result.unchecked) +
                      " " +
                      _vm._s(
                        _vm.result.unchecked === 1 ? "address" : "addresses"
                      ) +
                      " could not be checked right now.\n      "
                  )
                ])
              : _vm._e(),
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Student")]),
                  _c("th", [_vm._v("Address")]),
                  _c("th", [_vm._v("Status")])
                ])
              ]),
              _c(
                "tbody",
                _vm._l(_vm.flagged, function(student) {
                  return _c("tr", { key: student.studentId }, [
                    _c("td", [_vm._v(_vm._s(student.name))]),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.formatAddress(student.address)) +
                          "\n              "
                      ),
                      student.suggestion
                        ? _c("div", { staticClass: "suggestion" }, [
                            _vm._v(
                              "\n                Google suggests: " +
                                _vm._s(_vm.formatAddress(student.suggestion)) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c("td", [
                      student.status === "fix"
                        ? _c("span", { staticClass: "text-warning" }, [
                            _vm._v("Fix Available")
                          ])
                        : _c("span", { staticClass: "text-negative" }, [
                            _vm._v("Not Validated")
                          ])
                    ])
                  ])
                })
              )
            ])
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: {
                  color: "positive",
                  icon: "done",
                  label: "Approve Anyway"
                },
                nativeOn: {
                  click: function($event) {
                    _vm.$emit("approve")
                  }
                }
              }),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                nativeOn: {
                  click: function($event) {
                    _vm.$emit("cancel")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }